import React from 'react';

const icon5 = () => {
    return (
        <>
         <svg
                    width="50"
                    height="51"
                    viewBox="0 0 50 51"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.16602 12.8203C4.16602 11.7153 4.605 10.6554 5.3864 9.87404C6.16781 9.09264 7.22761 8.65366 8.33268 8.65366H41.666C42.7711 8.65366 43.8309 9.09264 44.6123 9.87404C45.3937 10.6554 45.8327 11.7153 45.8327 12.8203V37.8203C45.8327 38.9254 45.3937 39.9852 44.6123 40.7666C43.8309 41.548 42.7711 41.987 41.666 41.987H8.33268C7.22761 41.987 6.16781 41.548 5.3864 40.7666C4.605 39.9852 4.16602 38.9254 4.16602 37.8203V12.8203Z"
                      stroke="white"
                      strokeWidth="4.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.16602 16.987H45.8327"
                      stroke="white"
                      strokeWidth="4.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.16602 25.3203H18.7493C18.7493 27.4036 19.9993 31.5703 24.9993 31.5703C29.9993 31.5703 31.2493 27.4036 31.2493 25.3203H45.8327"
                      stroke="white"
                      strokeWidth="4.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
            
        </>
    );
};

export default icon5;